export default {
  components: {
    dialog: {
      overlayClass: 'dialog-overlay',
      dialogClass: 'dialog',
      transition: { name: 'dialog' },
    },
  },
};
